import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { loginCompleteUserProfile } from '@api/profile';
import {
  removeAuthTokenFromLocalStorage,
  removeRefreshTokenFromLocalStorage,
  setAuthTokenToLocalStorage,
  setRefreshTokenToLocalStorage,
} from '@utils/token';

import { handleLogin, handleRefreshToken } from './actions';
import { ITokenState, IUpdateTokens } from './slice.interface';

const initialState: ITokenState = {
  authToken: null,
  refreshToken: null,
};

export const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    removeToken: (state: ITokenState) => {
      removeAuthTokenFromLocalStorage();
      removeRefreshTokenFromLocalStorage();

      state.authToken = null;
      state.refreshToken = null;
    },
    updateTokens: (state: ITokenState, action: PayloadAction<IUpdateTokens>) => {
      setAuthTokenToLocalStorage(action.payload.authToken);
      action.payload.refreshToken && setRefreshTokenToLocalStorage(action.payload.refreshToken);

      state.authToken = action.payload.authToken;
      state.refreshToken = action.payload.refreshToken;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleRefreshToken.fulfilled, (state: ITokenState, action) => {
        setAuthTokenToLocalStorage(action.payload.data.id_token);

        state.authToken = action.payload.data.id_token;
      })
      .addCase(handleLogin.fulfilled, (state: ITokenState, action) => {
        setAuthTokenToLocalStorage(action.payload.data.id_token);
        setRefreshTokenToLocalStorage(action.payload.data.refresh_token);

        state.authToken = action.payload.data.id_token;
        state.refreshToken = action.payload.data.refresh_token;

        loginCompleteUserProfile();
      });
  },
});

export const { removeToken, updateTokens } = tokenSlice.actions;

export default tokenSlice.reducer;
